import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import PackagingDamageDispatchListView from 'src/sections/packaging-damage-dispatch/view/packaging-damage-dispatch-list-view';

export default function PackagingDamageDispatchListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Packaging Damage Dispatch</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_PACKAGING_DAMAGE_DISPATCH,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <PackagingDamageDispatchListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
